import { combineReducers } from 'redux';

import authority from './authority/reducers';
import user from './user/reducers';

const userReducer = combineReducers({
  authority,
  user,
});

export default userReducer;

export type UserState = ReturnType<typeof userReducer>;
